import React from 'react';
import Alert from '../../components/Alert';

const { id: module_id } = module;

export const ViksuConnectionError = () => {
  return (
    <Alert
      className={'text-center'}
      isHtml={true}
      message={`${module_id}.viksu.connection.error`}
    ></Alert>
  );
};
